<template>
  <div
    class="app-main-inner"
    style="display: flex;flex-direction: column"
  >
    <div class="app-main-inner-row">
      <div class="filters">
        <template v-if="readOnly">
          <el-button type="primary" @click="showAdd">{{ (treeNode && isRoot) ? $t('SystemMaintenance.CreateStatus'):$t('SystemMaintenance.CreateStatusDetail') }}</el-button>
          <el-button type="primary" @click="showEdit">{{ $t('SystemMaintenance.Edit') }}</el-button>
          <el-button type="danger" :disabled="!treeNode || isRoot" @click="toDel">{{ $t('SystemMaintenance.Delete') }}</el-button>
        </template>
        <template v-else>
          <el-button type="primary" @click="save">{{ $t('SystemMaintenance.Save') }}</el-button>
          <el-button type="primary" @click="cancel">{{ $t('SystemMaintenance.Cancel') }}</el-button>
          <el-button v-show="!isNew" type="danger" @click="toDel">{{ $t('SystemMaintenance.Delete') }}</el-button>
        </template>
      </div>
    </div>
    <div v-show="showFormCard" class="app-main-inner-row">
      <el-card class="box-card">
        <div slot="header">
          <span>{{ !isNew?$t('SystemMaintenance.EditStatus'):$t('SystemMaintenance.CreateStatus') }}</span>
        </div>
        <el-form ref="trackingForm" :disabled="readOnly" style="width:100%;" label-position="left" label-width="90px">
          <el-form-item :label="$t('SystemMaintenance.SerialNumber')">
            <el-input-number
              v-model="trackingForm.level"
              controls-position="right"
            />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.Code')">
            <el-input v-model="trackingForm.code" />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.ChineseName')">
            <el-input v-model="trackingForm.codeCname" />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.EnglishName')">
            <el-input v-model="trackingForm.codeEname" />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.NodeType')">
            <el-select v-model="trackingForm.nodeType" clearable class="input-w">
              <el-option v-for="(item,index) in $constantI18n('nodeType')" :key="index" :label="item.name" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.NodeType')">
            <el-checkbox v-model="trackingForm.published">{{ $t('SystemMaintenance.PublicOrNot') }}</el-checkbox>
          </el-form-item>
          <el-form-item label="OFFSETDAY">
            <el-input-number v-model="trackingForm.offsetDay" controls-position="right" :min="0" /></el-form-item>
          <el-form-item label="OFFSETHOUR">
            <el-input-number v-model="trackingForm.offsetHour" controls-position="right" :min="0" /></el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_QuicklyConfigureSettings')">
            <el-checkbox v-model="trackingForm.quickConfiguration">
              {{ $t('CargoMsg.Cargo_QuickConfigurationIsCheckedByDefault') }}</el-checkbox>
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.Remark')">
            <el-input
              v-model="trackingForm.remark"
              type="textarea"
              :rows="3"
            />
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { delTracking, getTrackingByUuid, saveTracking } from '@/api/sysManage/baseConfig/businessManage'
import * as trackingServiceApi from '@/api/trackingService'
import { Assert } from '@/utils/validate'

export default {
  name: 'Tracking',
  props: {
    treeNode: { type: Object, default: null },
    trackingTree: { type: Object, default: null }
  },
  data() {
    return {
      opStatus: 'read', // 操作状态：add|edit|read
      trackingForm: {
        uuid: '',
        lob: '',
        level: '',
        stateType: '',
        code: '',
        codeCname: '',
        codeEname: '',
        nodeType: 1,
        published: '',
        offsetDay: '',
        offsetHour: ''
      }
    }
  },
  computed: {
    // 是否一级节点
    isRoot() {
      return this.treeNode ? Boolean(this.treeNode.root) : false
    },
    showFormCard() {
      // 有选中行且非根节点或编辑状态时显示form表单
      return (this.treeNode && !this.isRoot) || this.isEdit || this.isNew
    },
    isNew() {
      return this.opStatus === 'add'
    },
    isEdit() {
      return this.opStatus === 'edit'
    },
    readOnly() {
      return this.opStatus === 'read'
    }
  },
  mounted() {
  },
  methods: {
    onShow() {
      Object.assign(this.trackingForm, this.treeNode)
      this.initStatus()
      this.initForm()
    },
    initStatus() {
      this.opStatus = 'read'
    },
    initForm() {
      if (this.treeNode && !this.isRoot) {
        const loading = getLoading()
        getTrackingByUuid(this.treeNode.uuid).then(res => {
          this.trackingForm = { ...res.data }
        }).finally(() => loading.close())
      }
    },
    showAdd() {
      if (!this.treeNode || this.isRoot) {
        let num = 0
        this.trackingTree.gridOptions.api.forEachNode((node, index) => {
          if (this.treeNode.uuid === node.data.parentUuid) {
            if (node.data.level > num) {
              num = node.data.level
            }
          }
        })
        this.trackingForm = {
          uuid: '',
          lob: '',
          level: num + 1,
          stateType: '',
          code: '',
          codeCname: '',
          codeEname: '',
          nodeType: 1,
          published: '',
          offsetDay: '',
          offsetHour: ''
        }
        this.opStatus = 'add'
      } else {
        // 新增明细
        this.$emit('addTrackingDetail', { uuid: this.trackingForm.uuid })
      }
    },
    showEdit() {
      if (!this.isRoot) {
        this.opStatus = 'edit'
      }
    },
    async toDel() {
      await this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.confirm'), { dangerouslyUseHTMLString: true, type: 'warning' })
      this.loading = getLoading()
      trackingServiceApi.delTrackingNode(this.trackingForm.uuid).then(resp => {
        delTracking(this.trackingForm.uuid).then(res => {
          const { lob: parentUuid } = this.trackingForm
          this.$message.success(this.$t('SystemMaintenance.DeleteSuccess'))
          this.$emit('refreshTree', { action: 'delete', data: { uuid: parentUuid, parentUuid }})
        })
      }).finally(() => {
        this.loading.close()
      })
    },
    async save() {
      await this.checkForm()
      this.loading = getLoading()
      this.trackingForm.lob = this.treeNode.path.split(',')[0]
      saveTracking(this.trackingForm, this.trackingForm.uuid).then(async res => {
        const { uuid, lob, codeEname: englishName, codeCname: chineseName, code } = { ...res.data }
        this.$message.success(this.$t('SystemMaintenance.SaveSuccess'))
        const data = { path: `${lob},${uuid}`, type: 2, uuid, code, parentUuid: lob, chineseName, englishName }
        this.$emit('refreshTree', { action: this.isNew ? 'add' : 'edit', data })
      }).finally(() => {
        this.loading.close()
      })
    },
    async  checkForm() {
      const { code, nodeType, codeCname, codeEname } = { ...this.trackingForm }
      await Assert.isNotBlank(code, this.$t('SystemMaintenance.PleaseEnterCode'))
      await Assert.isNotBlank(nodeType, this.$t('SystemMaintenance.PleaseEnterNodeType'))
      await Assert.isNotBlank(codeCname, this.$t('SystemMaintenance.PleaseEnterCodeChineseName'))
      await Assert.isNotBlank(codeEname, this.$t('SystemMaintenance.PleaseEnterCodeEnglishName'))
    },
    cancel() {
      this.initStatus()
      this.initForm()
    }
  }
}
</script>

<style scoped>

</style>
